module.exports = __webpack_public_path__ + "static/img/12.a19cca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity2024112/12.png
// module id = W4Xp
// module chunks = 0